import { jwtDecode } from "jwt-decode";

export interface DecodedToken {
    tenantId?: string;
    userId?: string;
    exp?: number;
    iat?: number;
    [key: string]: any;
}

/**
 * Decode the auth token from localStorage safely
 */
export const decodeAuthToken = (): DecodedToken | null => {
    const token = localStorage.getItem('autopath_access_token');
    if (!token) return null;

    try {
        return jwtDecode<DecodedToken>(token);
    } catch (error) {
        // console.error("Failed to decode JWT:", error);
        return null;
    }
};

/**
 * Get current tenantId with fallback
 */
export const getTenantId = (fallback = 'ORG31a26e77e23a4c1b'): string => {
    const decoded = decodeAuthToken();
    return decoded?.tenantId || fallback;
};

/**
 * Get current userId
 */
export const getUserId = (): string | undefined => {
    const decoded = decodeAuthToken();
    return decoded?.userId;
};

/**
 * Get full auth context (most commonly used)
 */
export const getAuthContext = () => {
    const decoded = decodeAuthToken();
    const token = localStorage.getItem('autopath_access_token');

    // console.log('Auth Context:', { // Add this line
    //     decoded,
    //     token,

    // });

    return {
        token,
        tenantId: decoded?.tenantId || '698adcb3e8d51839ed1ed501',
        userId: decoded?.userId || 'u_4ff5b788-f11f-4e2b-9693-ee680d41288e',
        isValid: !!decoded && !!token,
    };
};